<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Custom Clearance Charges</h3>
    </div>
  </div>

  <div class="card-body pt-0">
    <form [formGroup]="customClearanceForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="row">
        <!-- Passenger Car SUV and Van -->
        <div class="col-md-6 mb-5">
          <label class="form-label required">Passenger Car SUV and Van</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control form-control-solid"
              formControlName="passenger_car_suv_van"
              placeholder="Enter amount"
              min="0"
              step="0.01"
              [class.is-invalid]="passengerCarSuvVan?.invalid && passengerCarSuvVan?.touched"
            />
            <span class="input-group-text">JPY</span>
          </div>
          <div *ngIf="passengerCarSuvVan?.invalid && passengerCarSuvVan?.touched" class="invalid-feedback d-block">
            <div *ngIf="passengerCarSuvVan?.errors?.['required']">Amount is required</div>
            <div *ngIf="passengerCarSuvVan?.errors?.['min']">Amount must be 0 or greater</div>
          </div>
        </div>

        <!-- Truck -->
        <div class="col-md-6 mb-5">
          <label class="form-label required">Truck</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control form-control-solid"
              formControlName="truck"
              placeholder="Enter amount"
              min="0"
              step="0.01"
              [class.is-invalid]="truck?.invalid && truck?.touched"
            />
            <span class="input-group-text">JPY</span>
          </div>
          <div *ngIf="truck?.invalid && truck?.touched" class="invalid-feedback d-block">
            <div *ngIf="truck?.errors?.['required']">Amount is required</div>
            <div *ngIf="truck?.errors?.['min']">Amount must be 0 or greater</div>
          </div>
        </div>

        <!-- Hidden Type Field -->
        <input type="hidden" formControlName="type" />
      </div>

      <div class="row">
        <div class="col-12">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
            [disabled]="isLoading || customClearanceForm.invalid">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
